import { render, staticRenderFns } from "./TestIcon.vue?vue&type=template&id=32dcab11&"
import script from "./TestIcon.vue?vue&type=script&lang=js&"
export * from "./TestIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports